<template src="../templates/normal_fcont_127.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga';
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'

import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '127',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,
    PrintButton,ReleaseDateForArticle,AppDownloadColorioNenga,AppDownloadPhotoPlusJp
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['127-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['127-2']}
    ]};
  }
  
};
</script>
<style >
</style>

